import React, { Component } from 'react';
import HeaderBanner from '../../components/HeaderBanner';
import SummaryPanel from '../../components/SummaryPanel';
import InfoBlock from '../../components/InfoBlock';
import styles from './index.scss';

class TradeUpsFirstStep extends Component {
    /**
     * Renders component
     * @returns {*}
     */
    render() {
        return (
            <div className={styles.tradeUpsWrapper}>
                <HeaderBanner header="keyword_Trade-UPS" />
                <div className="tradeUpsContainer">
                    <SummaryPanel />
                </div>
                <InfoBlock />
            </div>
        );
    }
}

export default TradeUpsFirstStep;
